import ReactDOM from 'react-dom/client';
import React from 'react';
import { v2Component } from '../../../index';
import { TenantContext } from '../../../context/tenant-context';
import { ToastContainer } from 'react-toastify';
import { InvoiceLogoUpload } from './invoice-logo-upload';

export function initInvoiceLogoUpload(element?: HTMLElement) {
  const elements = element !== undefined ? [element] : document.getElementsByName('invoice-logo-upload');

  elements.forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);
      const bootstrap = () => {
        const { tenant, contextPath, ...dataset } = Object.assign({}, element.dataset) as any;
        const props = {
          ...dataset,
        };

        root.render(
          v2Component(
            <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
              <ToastContainer />
              <InvoiceLogoUpload {...props} />
            </TenantContext.Provider>,
          ),
        );
      };
      bootstrap();
    }
  });
}
